var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8835 5.31213C11.8835 5.31213 11.5215 9.80213 11.3115 11.6935C11.2115 12.5968 10.6535 13.1261 9.73952 13.1428C8.00019 13.1741 6.25885 13.1761 4.52018 13.1395C3.64085 13.1215 3.09218 12.5855 2.99418 11.6981C2.78285 9.79013 2.42285 5.31213 2.42285 5.31213",
    stroke: "#5C5F62",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8053 3.15981H1.5",
    stroke: "#5C5F62",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6274 3.1598C10.104 3.1598 9.65338 2.7898 9.55071 2.27713L9.38871 1.46647C9.28871 1.09247 8.95004 0.833801 8.56404 0.833801H5.74204C5.35604 0.833801 5.01738 1.09247 4.91738 1.46647L4.75538 2.27713C4.65271 2.7898 4.20204 3.1598 3.67871 3.1598",
    stroke: "#5C5F62",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.e9a2b780aa2400409e1a334a78bce8f1.svg";
export { ForwardRef as ReactComponent };